import styled from 'styled-components';
import { Pagination } from 'antd';

const COLORS = {
	TEXT: '#262626',
	BACKGROUND_LINK: '#F0F2F5',
	BACKGROUND_LINK_ACTIVE: '#EAEFFD',
	BACKGROUND_LI: '#f0f0f0',
	LI_TEXT: '#BFBFBF',
	LI_TEXT_ACTIVE: '#002FBB'
};

export const PaginationCustom = styled(Pagination)`
	.ant-pagination-item {
		border: none;
		border-radius: 5px;
		background-color: ${COLORS.BACKGROUND_LI};

		a {
			color: ${COLORS.LI_TEXT};

			&:hover {
				color: ${COLORS.LI_TEXT_ACTIVE};
			}
		}
	}

	.ant-pagination-item-active {
		a {
			color: ${COLORS.LI_TEXT_ACTIVE};
		}
	}

	.ant-pagination-item:nth-last-of-type(2) {
		margin-right: 0 !important;
	}
	.ant-pagination-item-active {
		background-color: ${COLORS.BACKGROUND_LINK_ACTIVE};
	}

	.ant-pagination-prev,
	.ant-pagination-next {
		margin: 0;
	}

	.ant-pagination-item-link {
		background-color: transparent !important;
		border: none !important;
	}
`;

export const PaginationInfo = styled.div`
	font-size: 14px;
	font-weight: 400;
	line-height: 16px;
	color: ${COLORS.TEXT};
`;
